import React, { useState } from 'react';
import SmallScreenMenu from '../Sidebar/Navigation/SmallScreenMenu';
import LargeScreenMenu from '../Sidebar/Navigation/LargeScreenMenu';
import Main from '../Main/Main';
import useCurrentUser from '../../data/CurrentUser/CurrentUserQuery'
import { useContext } from 'react'
import { userContext } from '../../components/Auth/AuthContext';

export const Home = () => {
    const currentUser = useContext(userContext)
    const uid = currentUser.user.uid
    const CurrentUserQuery = useCurrentUser(uid)
    const [menuIsOpen, setMenuIsOpen] = useState(false)

    const handleClick = () => {
        setMenuIsOpen(!menuIsOpen)
    }

    return (
        <div className="h-screen flex overflow-hidden bg-white">
            <SmallScreenMenu handleClick={handleClick} menuIsOpen={menuIsOpen} currentUser={CurrentUserQuery.data} />
            <LargeScreenMenu currentUser={CurrentUserQuery.data} />
            <Main handleClick={handleClick} menuIsOpen={menuIsOpen} />
        </div>
    )
}